import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isNotFoundError } from '../utils/api-error';

export const useRedirectHomeOnNotFound = (
    error: unknown,
    isLoading = false,
    enabled = true
): void => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!enabled || isLoading) return;
        if (isNotFoundError(error)) {
            navigate('/');
        }
    }, [error, isLoading, enabled, navigate]);
};
